// WICHTIG: Diese Datei NICHT in extensions/ deployen.
// Stattdessen: Shopify Admin -> Onlineshop -> Themes -> Code bearbeiten
// -> Assets -> Datei hinzufügen -> "pfand.js" -> diesen Code einfügen -> Speichern
//
// Danach in layout/theme.liquid VOR </body> einfügen:
// <script src="{{ 'pfand.js' | asset_url }}" defer></script>
//
// Pfand-Produkte müssen vorher in Shopify angelegt werden mit Handle:
// pfand-7ct, pfand-15ct, pfand-25ct (Status: "Nicht gelistet", kein Inventar-Tracking)
//
// Bundle-Produkte (z.B. 3er-Pack) brauchen den Tag: pfand-multiplier-3 (oder -6, -12, -24 etc.)

(function() {
  const PFAND_HANDLES = { 7: 'pfand-7ct', 25: 'pfand-25ct' };
  const SHOP = window.Shopify?.shop || '';
  const API_URL = 'https://snackshark-pro.vercel.app/api/pfand-data?shop=' + SHOP;
  const IS_CART_PAGE = window.location.pathname === '/cart';
  let pfandMap = {};
  let isUpdating = false;
  let tagsCache = {};

  // Pfand-Links im Cart nicht klickbar machen
  const pfandStyle = document.createElement('style');
  pfandStyle.textContent = `
    a[href*="pfand-25ct"],
    a[href*="pfand-7ct"],
    a[href*="pfand-15ct"] {
      pointer-events: none !important;
      cursor: default !important;
    }
  `;
  document.head.appendChild(pfandStyle);

  function blockCheckout() {
    document.querySelectorAll([
      '[name="checkout"]',
      '[href="/checkout"]',
      'a[href*="checkout"]',
      '.qsc2-checkout-button',
      'button[aria-label="Checkout button"]'
    ].join(', ')).forEach(btn => {
      btn.setAttribute('data-pfand-blocked', 'true');
      btn.style.opacity = '0.6';
      btn.style.pointerEvents = 'none';
    });
  }

  function unblockCheckout() {
    document.querySelectorAll('[data-pfand-blocked]').forEach(btn => {
      btn.removeAttribute('data-pfand-blocked');
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
    });
  }

  // Beobachtet neu hinzugefügte Checkout-Buttons (z.B. von qikify Slider)
  const checkoutObserver = new MutationObserver(() => {
    if (isUpdating) blockCheckout();
  });
  checkoutObserver.observe(document.body, { childList: true, subtree: true });

  async function loadPfandData() {
    try {
      const res = await fetch(API_URL);
      pfandMap = await res.json();
    } catch(e) { console.log('Pfand Fehler:', e); }
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function getProductTags(handle) {
    if (tagsCache[handle]) return tagsCache[handle];
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return [];
      const product = await res.json();
      tagsCache[handle] = product.tags || [];
      return tagsCache[handle];
    } catch { return []; }
  }

  async function getPfandVariantId(cents) {
    const handle = PFAND_HANDLES[cents];
    if (!handle) return null;
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      const product = await res.json();
      return product.variants[0]?.id || null;
    } catch { return null; }
  }

  async function checkNeedsUpdate(items) {
    const pfandHandles = Object.values(PFAND_HANDLES);
    const regularItems = items.filter(item => !pfandHandles.includes(item.handle));
    const currentPfandItems = items.filter(item => pfandHandles.includes(item.handle));

    let pfandSummary = {};
    for (const item of regularItems) {
      const cents = pfandMap[item.handle];
      if (!cents) continue;
      // Bundle-Multiplikator über Produkt-Tag erkennen (z.B. pfand-multiplier-3)
      const tags = await getProductTags(item.handle);
      const multiplierTag = tags.find(t => t.startsWith('pfand-multiplier-'));
      const multiplier = multiplierTag ? parseInt(multiplierTag.replace('pfand-multiplier-', '')) : 1;
      pfandSummary[cents] = (pfandSummary[cents] || 0) + (item.quantity * multiplier);
    }

    let needsUpdate = false;
    for (const [cents, count] of Object.entries(pfandSummary)) {
      const handle = PFAND_HANDLES[parseInt(cents)];
      const current = currentPfandItems.find(i => i.handle === handle);
      if (!current || current.quantity !== count) { needsUpdate = true; break; }
    }
    if (currentPfandItems.length > 0 && Object.keys(pfandSummary).length === 0) needsUpdate = true;

    return { needsUpdate, pfandSummary, currentPfandItems };
  }

  async function updatePfand() {
    if (isUpdating) return;
    isUpdating = true;
    blockCheckout();

    try {
      const cart = await getCart();
      const { needsUpdate, pfandSummary, currentPfandItems } = await checkNeedsUpdate(cart.items);

      if (needsUpdate) {
        // Bestehende Pfand-Items entfernen
        for (const pfandItem of currentPfandItems) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: pfandItem.key, quantity: 0 })
          });
        }

        // Neue Pfand-Items hinzufügen (zusammengefasst pro Betrag)
        for (const [cents, count] of Object.entries(pfandSummary)) {
          if (count <= 0) continue;
          const variantId = await getPfandVariantId(parseInt(cents));
          if (!variantId) continue;
          const totalCents = parseInt(cents) * count;
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: count,
              properties: {
                '_is_pfand': 'true',
                '_pfand_label': `Pfand (${count}x ${(parseInt(cents)/100).toFixed(2).replace('.',',')}€) = ${(totalCents/100).toFixed(2).replace('.',',')}€`
              }
            })
          });
        }

        if (IS_CART_PAGE) {
          window.location.reload();
          return;
        }
      }
    } catch(e) {
      console.log('Pfand update error:', e);
    } finally {
      isUpdating = false;
      unblockCheckout();
    }
  }

  // Letzte Sicherheitslinie: Checkout-Klick abfangen falls Pfand noch nicht aktuell ist
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('.qsc2-checkout-button, [name="checkout"], a[href="/checkout"], button[aria-label="Checkout button"]');
    if (!btn) return;

    const cart = await getCart();
    const { needsUpdate } = await checkNeedsUpdate(cart.items);

    if (needsUpdate) {
      e.preventDefault();
      e.stopImmediatePropagation();
      await updatePfand();
      if (!IS_CART_PAGE) {
        window.location.href = '/checkout';
      }
    }
  }, true);

  function triggerUpdate() {
    clearTimeout(window._pfandTimeout);
    window._pfandTimeout = setTimeout(updatePfand, 500);
  }

  // Cart-Änderungen über fetch() abfangen
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : '';
    const result = originalFetch.apply(this, args);
    if (!isUpdating && (url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change'))) {
      result.then(triggerUpdate);
    }
    return result;
  };

  document.addEventListener('cart:updated', triggerUpdate);
  document.addEventListener('cart-drawer:open', triggerUpdate);

  document.addEventListener('DOMContentLoaded', async () => {
    await loadPfandData();
    await updatePfand();
  });
})();
